module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "assembleSubtest"
    }
  }, [_c('div', [(_vm.$store.state.tryout.status != 'PUBLISHED') ? _c('table', [_c('tr', [_c('td', [(_vm.subtestType == 'normal') ? _c('app-autocomplete', {
    attrs: {
      "data": _vm.topics,
      "depth": "2",
      "placeholder": "Cari bab / sub bab ...",
      "resetable": "true"
    },
    on: {
      "selected": function($event) {
        return _vm.assignTopic($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subtestType == 'anchor') ? _c('app-itemchooser', {
    attrs: {
      "subject": _vm.selectedSubject
    },
    on: {
      "selected": function($event) {
        return _vm.assignAnchor($event)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subtestType),
      expression: "subtestType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.subtestType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "normal"
    }
  }, [_vm._v("Normal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "anchor"
    }
  }, [_vm._v("Anchor")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-hover"
  }, _vm._l((_vm.details), function(subtestDetail, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (subtestDetail.is_anchor) ? _c('td', [_vm._v("\n                    Kode Soal: " + _vm._s(subtestDetail.item_code) + "\n                ")]) : _c('td', [_vm._v("Topik: " + _vm._s(_vm.getTopicText(subtestDetail)))]), _vm._v(" "), (_vm.$store.state.tryout.status != 'PUBLISHED') ? _c('td', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-success btn-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.moveDown(subtestDetail)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-caret-down"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.moveUp(subtestDetail)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-caret-up"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.remove(subtestDetail)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-times"
    })])]) : _vm._e()])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54e90e03","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tryout/AssembleSubTest.vue
// module id = 1498
// module chunks = 1